<template>
  <Menu ref="menu" :active-name="activeName" theme="light" width="auto" :open-names="[openNames]">
    <Submenu name="1">
      <template slot="title">
        <Icon type="ios-navigate"></Icon>
        内容管理
      </template>
      <MenuItem name="1-1" :to="{path: '/manage/news/check/list'}">内容审核</MenuItem>
      <MenuItem name="1-2" :to="{path: '/manage/news/list'}">内容管理</MenuItem>
      <MenuItem name="1-3" :to="{path: '/manage/news/add'}">发布内容</MenuItem>
      <MenuItem name="1-4" :to="{path: '/manage/news/search'}">内容搜索</MenuItem>
    </Submenu>
    <Submenu name="2">
      <template slot="title">
        <Icon type="ios-keypad"></Icon>
        机构管理
      </template>
      <MenuItem name="2-1" :to="{path: '/manage/association/mine/show'}">机构信息</MenuItem>
      <MenuItem name="2-2" :to="{path: '/manage/association/list'}" v-if="adminInfo.level==99">机构管理</MenuItem>
      <MenuItem name="2-3" :to="{path: '/manage/association/other/add'}" v-if="adminInfo.level==99">机构创建</MenuItem>
    </Submenu>
    <Submenu name="3">
      <template slot="title">
        <Icon type="ios-analytics"></Icon>
        会员管理
      </template>
      <MenuItem name="3-1" :to="{path: '/manage/members/list'}">会员管理</MenuItem>
      <MenuItem name="3-2" :to="{path: '/manage/members/add'}">添加会员</MenuItem>
      <MenuItem name="3-3" :to="{path: '/manage/members/search'}">会员搜索</MenuItem>
    </Submenu>
    <Submenu name="4">
      <template slot="title">
        <Icon type="ios-settings"></Icon>
        站点设置
      </template>
      <MenuItem name="4-1" :to="{path: '/manage/users/list'}" v-if="adminInfo.level==99">管理员设置</MenuItem>
      <MenuItem name="4-2" :to="{path: '/manage/users/add'}" v-if="adminInfo.level==99">添加管理员</MenuItem>
      <MenuItem name="4-3" :to="{path: '/manage/sliders/banners/add'}">上传首页图片</MenuItem>
      <MenuItem name="4-4" :to="{path: '/manage/sliders/banners/list'}">首页Banner</MenuItem>
      <MenuItem name="4-5" :to="{path: '/manage/sliders/news/list'}">首页协会新闻</MenuItem>
      <MenuItem name="4-6" :to="{path: '/manage/sliders/videos/list'}">首页视频报道</MenuItem>
      <MenuItem name="4-7" :to="{path: '/manage/sliders/colors/list'}">首页多彩人生</MenuItem>
    </Submenu>
    <MenuItem name="5" >
        <a @click="adminLogout" style="color:#515a6e;">
        <Icon type="ios-shuffle" />
        退出登录
        </a>
    </MenuItem>
  </Menu>
</template>
<script>
export default {
  data() {
    return {
      activeName: "",
      openNames: "",
      activeMenus: {
        AdminAssociationEdit: {
          openNames: "2",
          activeName: "2-1"
        },
        AdminAssociationList: {
          openNames: "2",
          activeName: "2-2"
        },
        AdminAssociationOtherAdd: {
          openNames: "2",
          activeName: "2-3"
        },
        AdminAssociationOtherEdit: {
          openNames: "2",
          activeName: "2-2"
        },
        AdminAssociationShow: {
          openNames: "2",
          activeName: "2-1"
        },
        AdminAssociationShowOther: {
          openNames: "2",
          activeName: "2-2"
        },
        AdminHome: {
          openNames: "",
          activeName: ""
        },
        AdminUsersList:{
          openNames: "4",
          activeName: "4-1"
        },
        AdminUsersAdd:{
          openNames: "4",
          activeName: "4-2"
        },
        AdminIndexBanner: {
          openNames: "4",
          activeName: "4-4"
        },
        AdminIndexBannerAdd: {
          openNames: "4",
          activeName: "4-3"
        },
        AdminIndexColors: {
          openNames: "4",
          activeName: "4-7"
        },
        AdminIndexNews: {
          openNames: "4",
          activeName: "4-5"
        },
        AdminIndexVideos: {
          openNames: "4",
          activeName: "4-6"
        },
        AdminUsersPasswordEdit: {
          openNames: "4",
          activeName: "4-1"
        },
        AdminMemberAdd: {
          openNames: "3",
          activeName: "3-2"
        },
        AdminMemberEdit: {
          openNames: "3",
          activeName: "3-1"
        },
        AdminMemberShow: {
          openNames: "3",
          activeName: "3-1"
        },
        AdminMembersList: {
          openNames: "3",
          activeName: "3-1"
        },
        AdminMembersSearch: {
          openNames: "3",
          activeName: "3-3"
        },
        AdminNewsAdd: {
          openNames: "1",
          activeName: "1-3"
        },
        AdminNewsCheckList: {
          openNames: "1",
          activeName: "1-1"
        },
        AdminNewsCheckShow: {
          openNames: "1",
          activeName: "1-1"
        },
        AdminNewsDeleteShow: {
          openNames: "1",
          activeName: "1-2"
        },
        AdminNewsEdit: {
          openNames: "1",
          activeName: "1-2"
        },
        AdminNewsList: {
          openNames: "1",
          activeName: "1-2"
        },
        AdminNewsSearchList: {
          openNames: "1",
          activeName: "1-4"
        },
      },

      //用户信息数据
      adminInfo: {},
    }
  },

  //页面加载完成
  mounted: function () {
    this.initPageData()
    this.initMenuStatus()
  },

  methods: {
    //初始化页面数据
    initPageData() {
      let admin = JSON.parse(localStorage.getItem("adminInfo"));
      if(admin != null) {
        this.adminInfo = admin
      }
    },
    //初始化菜单
    initMenuStatus() {
      
      var actionName = this.$router.currentRoute.name
      var menuContent = this.activeMenus[actionName]
      this.openNames = menuContent.openNames
      this.activeName = menuContent.activeName
      
      //this.menuActive = "";  
      this.$nextTick(()=>{
          this.$refs.menu.updateOpened();
          this.$refs.menu.updateActiveName();
      })
    },

    //用户退出
    adminLogout() {
      localStorage.removeItem("adminInfo")
      window.location.reload()
    },
  }
  
}
</script>